import { useEffect, useState } from "react";
import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useAppDispatch } from "../../../../app/hooks";
import { CancelButton } from "../../../../app/components/CancelButton";
import { YesButton } from "../../../../app/components/YesButton";
import {
    DocumentWorkflowDefinitionDto,
    removeDocumentTeamMemberFromWorkflow,
} from "../documentWorkflowApi";

type DeleteWorkflowTeamMemberDialogProps = {
    open: boolean;
    documentId?: number | string | null;
    userName?: string;
    onSuccess: (definition: DocumentWorkflowDefinitionDto) => void;
    onClose: () => void;
};

export const DeleteWorkflowTeamMemberDialog = ({
    open,
    documentId,
    userName,
    onSuccess,
    onClose,
}: DeleteWorkflowTeamMemberDialogProps) => {
    const dispatch = useAppDispatch();
    const [isDeleting, setIsDeleting] = useState(false);
    const [serverError, setServerError] = useState("");

    useEffect(() => {
        if (open) {
            setIsDeleting(false);
            setServerError("");
        }
    }, [open]);

    const getServerErrorMessage = (result: any) => {
        let errorMsg = "error";
        if (result.payload && result.payload.kind === "http") {
            const problem = result.payload.problem;
            if (problem?.title) {
                errorMsg = problem.title;
            }
        }
        return errorMsg;
    };

    const handleConfirm = async () => {
        if (!documentId || !userName || isDeleting) {
            return;
        }

        setIsDeleting(true);
        setServerError("");

        const result = await dispatch(
            removeDocumentTeamMemberFromWorkflow({
                documentId: String(documentId),
                userName,
            })
        );

        if (removeDocumentTeamMemberFromWorkflow.fulfilled.match(result)) {
            onSuccess(result.payload);
        } else {
            setServerError(getServerErrorMessage(result));
        }

        setIsDeleting(false);
    };

    return <Dialog open={open} fullWidth maxWidth="xs">
        <DialogTitle>Usun z zespolu</DialogTitle>
        <DialogContent>
            <Alert severity="warning" sx={{ mt: 1 }}>
                Czy na pewno usunac osobe z zespolu workflow?
            </Alert>
            {serverError && (
                <Alert severity="error" sx={{ mt: 1 }} onClose={() => setServerError("")}>
                    <Localized id={serverError}>
                        <span>{serverError}</span>
                    </Localized>
                </Alert>
            )}
        </DialogContent>
        <DialogActions>
            <YesButton loading={isDeleting} onClick={handleConfirm} disabled={isDeleting || !documentId || !userName} label="Tak, usun" />
            <CancelButton loading={isDeleting} onClick={onClose} disabled={isDeleting} />
        </DialogActions>
    </Dialog>;
};
